import './App.css';
import { BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import HeaderComponent from './Components/HeaderComponent/HeaderComponent';
import FooterComponent from './Components/FooterComponent/FooterComponent';
import Home from './Pages/Home/Home';

function App() {
  return (
    <div className="App">
      <HeaderComponent/>
      <main className="main-content">
        <BrowserRouter className="LateralNavbar" basename={"/"}>
          <Routes>
              <Route path="*" element={<Navigate to="/" />} />
              <Route path="/" element={<Home />}/>
          </Routes>
        </BrowserRouter>
      </main>
      <FooterComponent/>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.2/css/all.min.css"/>
    </div>
  );
}

export default App;
